import "./index.js";
import "#/shared/api/api-host-global.js";
import "./utilities/url_modifier.js";
import "./utilities/remote_content.js";
import "#legacy/utilities/event_detail.js";
import "#legacy/appointment_booking/index.js";
import "#legacy/analytics/index.js";

// CODE USED TO BOOTSTRAP THE DOCTOR FINDER ON A 3RD PARTY SITE
(function ($) {
  var CONFIG_URL =
    window.Sparkle.apiHost && window.SparkleConfig?.routes?.embed?.doctorFinderEmbed
      ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.doctorFinderEmbed
      : undefined;
  var TEMPLATE_URL =
    window.Sparkle.apiHost && window.SparkleConfig?.routes?.embed?.physiciansTemplate
      ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.physiciansTemplate
      : undefined;

  /*
  @param options Options hash
  @option options.uuid               Unique ID for the widget. If provided, configuration will be looked up from the `doctor_finder_embed` endpoint.
  @option options.urlParams          Url params to include on all links within the doctor finder, including autocomplete links
  @option options.urlMap             Key/value pairs of Matchers and Targets to map links to. Matcher can be a String or a RegExp. A String Matcher can
                                     include capture groups, e.g. "some/url/<my-capture>", whereas a RegExp matcher should follow JS RegExp syntax for
                                     capture groups. Target can be either a String or a Function. A String target can make use of capture groups from the
                                     Matcher, e.g. "some/mapped/url/<my-capture>". A Function target receives the matching portion of the url and should
                                     return a string that will replace the match.
  @option options.*                  Additional options are passed down to the doctor finder itself
  */
  Sparkle.Embed.DoctorFinder = function (containerId, options) {
    var container = Sparkle.Embed.Container.prepare("#" + containerId);

    options = jQuery.extend({}, options, {
      urlMap: Sparkle.Embed.Utilities.detectURLMap(),
    });
    var isSearchWhoWorksHere =
      new URLSearchParams(window.location.search).get("provider_search_context") == "search_who_works_here";
    var searchResultTypesOverride;
    if (isSearchWhoWorksHere) {
      searchResultTypesOverride = options.search && options.search.result_types;
      if (jQuery.isArray(searchResultTypesOverride)) {
        searchResultTypesOverride = searchResultTypesOverride.slice();
      }
    }

    window.ModalDefaults = jQuery.extend({}, window.ModalDefaults, { appendTo: container }); // Append modals to the container so we decorate those hrefs as well

    // If a UUID is provided, want to pass it to all links within the doctor finder for scoping recently viewed doctors
    if (options.uuid) {
      options.urlParams = jQuery.extend({}, options.urlParams, { search_uuid: options.uuid });
    }

    // INITIALIZE
    window.Sparkle.Analytics?.setCurrentWorkflow(window.SparkleConfig?.analytics?.workflows?.physicianBrowsing);

    // Tag analytics events with the search uuid (always tag even if no UUID present to standardize event handling)
    Sparkle.Utilities.setEventDetail(
      container,
      "search.sparkle search-select.sparkle autocomplete.sparkle autocomplete-select.sparkle click embed:play.sparkle embed:pause.sparkle embed:ended.sparkle play pause ended",
      { search_uuid: options.uuid },
    );

    var doctorFinderPromise = fetchConfig(options.uuid)
      .then(localizeRootPath)
      .then(function () {
        Sparkle.Embed.Utilities.decorateEmbeddedHrefs(container, options);
      }) // Map clicks on links handled by the host CMS. Wait until the config has arrived or we won't have the url map
      .then(fetchTemplate)
      .then(loadDoctorFinder)
      .then(readyComponent);

    return doctorFinderPromise;

    // HELPER FUNCTIONS

    function fetchConfig(uuid) {
      if (uuid) {
        // Localize the config (it carries UI strings, e.g. the finder's ui.i18n catalog)
        var url = Sparkle.Embed.Utilities.localizeUrl(
          Sparkle.Embed.Utilities.injectUrlWithEmbeddedAt(CONFIG_URL.replace("EMBED_UUID", uuid)),
        );
        return jQuery.getJSON(url, function (data) {
          options = jQuery.extend(true, data, options);
          // jQuery.extend(true) merges arrays by index, so the caller's narrower result_types
          // (["Physician"] from a "Search Who Works Here" link) would keep the embed config's
          // extra entries ("Location" survives at index 1) and the facility itself would
          // surface as a result card. Restore the caller's array wholesale.
          if (searchResultTypesOverride) {
            options.search = options.search || {};
            options.search.result_types = searchResultTypesOverride;
          }
        });
      } else {
        return jQuery.Deferred().resolve().promise();
      }
    }

    // The root path is the host page's bare path, and the router matches no route on a page outside its
    // root. On a host that takes the locale in its path the page is under the locale prefix, so the root
    // goes under it too: `/find-a-doctor` on `/es/find-a-doctor` is `/es/find-a-doctor`.
    function localizeRootPath() {
      if (!options.rootPath || typeof options.rootPath !== "string" || !Sparkle.Embed.Utilities.hostTakesPathLocale()) {
        return;
      }

      options.rootPath = Sparkle.Embed.Utilities.localizeHostUrl(
        options.rootPath,
        Sparkle.Embed.Utilities.currentLocale(),
      );
    }

    function fetchTemplate() {
      // Sets the default result types scope for Dr Finders configured outside of Admin.
      // Finders configured in JS predate Locations as results, so we default to Physicians.
      if (!options.managed && !(options.search && options.search.result_types && options.search.result_types.length)) {
        options.search = Object.assign({}, options.search, { result_types: ["Physician"] });
      }

      const finderConfig = {};
      const runtimeOptions = {
        open_scheduling: options.openScheduling,
        passive_boosts: options.passiveBoosts,
        slots_ui: options.ui && options.ui.slotsUI,
      };

      for (const [key, value] of Object.entries(runtimeOptions)) {
        if (value != null && !(typeof value === "string" && value.trim() === "")) {
          finderConfig[key] = value;
        }
      }

      const templateParams = {
        search: options.search,
        uuid: options.uuid,
      };

      if (Object.keys(finderConfig).length > 0) {
        templateParams.finder_config = finderConfig;
      }
      // We need to use the configuration options to generate the url params, so make sure we've applied any UUID-based configs before this request.
      // Forward the embed uuid so the template's `local_doctor_finder` resolves to THIS embed. The wizard template (`_search_header`,
      // facet partials) renders the omnisearch/specialty/provider elements with `local_doctor_finder.uuid`, which keys the shared
      // omnisearch store. TEMPLATE_URL is always the physicians endpoint, so without the uuid `local_doctor_finder` falls back to the
      // first published landing embed — correct for the physicians finder, but wrong for the locations finder (a different embed),
      // leaving its element keyed to an unconfigured store ("No data"). A blank uuid is dropped by modifyUrlParams (unmanaged finders).
      // The active locale rides along inside fetchRemoteContent (localizeUrl),
      // validated against the available locales — no raw `?locale=` forwarding here.

      return Sparkle.Embed.Utilities.fetchRemoteContent(
        Sparkle.Embed.Utilities.modifyUrlParams(TEMPLATE_URL, templateParams),
        container,
      );
    }

    function loadDoctorFinder() {
      // Disable sticky date selector for embedded doctor finders to prevent the date selector from overlapping provider names on mobile
      options.ui = options.ui || {};
      options.ui.results = options.ui.results || {};
      if (!("stickyDateSelector" in options.ui.results)) {
        options.ui.results.stickyDateSelector = false;
      }

      return AppointmentBooking.showDoctorFinder(jQuery(container).find("sp-provider-finder"), options);
    }

    function readyComponent() {
      Sparkle.Embed.Events.componentReady(container);
    }
  };
})(jQuery);
